import React, { useCallback } from "react";
import {
  Avatar,
  Grid,
  ListSubheader,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { ContactSupport, Event, Message } from "@material-ui/icons";
import { useHistory, useLocation } from "react-router-dom";
import {
  ENS_MODULE_NAME,
  MODULE_NAME,
  CONTACT_AO_MODULE_NAME,
} from "../../moduleName";
import { informationRequestService } from "../../services";
import { UserType } from "../../redux/types";
import { EnRoles } from "../../domain/userRole";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../../redux/selectors";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  item: {
    width: 250,
    marginTop: 10,
    marginBottom: 10,
  },
}));

type NewCommMenuProps = {
  anchorEl: Element | null;
  onClose: () => void;
};

export const NewCommMenu: React.FC<NewCommMenuProps> = ({
  anchorEl,
  onClose,
}) => {
  const classes = useStyles();

  const history = useHistory();
  const { search } = useLocation();
  const { userType, isInRole, token } = useAuth(authSelector);

  const enNavigate = () =>
    history.push(`${ENS_MODULE_NAME}/new`, {
      [SEARCH_STATE_KEY]: search,
    });

  const caoCreate = useCallback(async () => {
    let id = await informationRequestService.create({
      token,
    });
    history.push(`${CONTACT_AO_MODULE_NAME}/${id}`);
  }, [token, history]);

  const ctrNavigate = () =>
    history.push(`${MODULE_NAME}/new`, {
      [SEARCH_STATE_KEY]: search,
    });

  const isEnUser = isInRole(...EnRoles);

  return (
    <Menu
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={anchorEl}
      keepMounted
      open={!!anchorEl}
      onClose={onClose}
    >
      <ListSubheader data-test="new-comm-type-subheader">
        Communication Type
      </ListSubheader>
      {isEnUser ? (
        <MenuItem
          className={classes.item}
          onClick={enNavigate}
          data-test="event-notification-menu-item"
        >
          <Grid container spacing={3}>
            <Grid item>
              <Avatar>
                <Event />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="body2">
                Event <br />
                Notification
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      ) : null}
      {userType === UserType.Ofqual ? (
        <MenuItem
          className={classes.item}
          onClick={caoCreate}
          data-test="cao-menu-item"
        >
          <Grid container spacing={3}>
            <Grid item>
              <Avatar>
                <Message />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="body2">
                Contact Awarding
                <br />
                Organisation
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      ) : null}
      {userType === UserType.AO ? (
        <MenuItem
          className={classes.item}
          onClick={ctrNavigate}
          data-test="ctr-menu-item"
        >
          <Grid container spacing={3}>
            <Grid item>
              <Avatar>
                <ContactSupport />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="body2">
                Contact the
                <br />
                Regulator
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      ) : null}
    </Menu>
  );
};
